import React, { cloneElement } from 'react'
import PropTypes from 'prop-types'

import EditSection from '../EditSection'
import SkeletonMultipleSectionsForm from '../../../FormDrawerWrapper/Skeletons/SkeletonMultipleSectionsForm'

import useManageEditSections from '../../../../../hooks/formHooks/useManageEditSections'

import useStyles from './style'

// this component allows to control visibility by Preview and edit Form/Fields
const EditSectionsList = ({
  editSections,
  isEditDataLoading,
  editItemData,
  sectionsInitialOpenStates = {},
  formProps
}) => {
  const classes = useStyles()

  const { openSections, openSectionHandler, setHasUnsavedChanges, UnsavedChangesWarningModal } = useManageEditSections({
    sectionsInitialOpenStates
  })

  const renderComponentWithProps = ({ FormComponent, sectionName, title }) => {
    // populate component with props during the rendering
    return cloneElement(FormComponent, {
      ...formProps,
      editItemData,
      title,
      onEditClose: () => openSectionHandler(sectionName),
      onSuccessSubmit: () => openSectionHandler(sectionName),
      formName: `${sectionName}_FORM`,
      setUnsavedChanges: setHasUnsavedChanges
    })
  }

  return (
    <div className={classes.editSections}>
      {isEditDataLoading ? (
        <SkeletonMultipleSectionsForm withEditIcon />
      ) : (
        editSections.map(editSection => (
          <EditSection
            key={editSection.title + editSection.sectionName}
            title={editSection.title}
            isSectionOpen={openSections[editSection.sectionName]}
            toggleSectionVisibility={() => openSectionHandler(editSection.sectionName)}
            preview={editSection.PreviewComponent}
          >
            {renderComponentWithProps(editSection)}
          </EditSection>
        ))
      )}
      <UnsavedChangesWarningModal />
    </div>
  )
}

const editSectionShape = {
  sectionName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  PreviewComponent: PropTypes.node.isRequired,
  FormComponent: PropTypes.node.isRequired
}
EditSectionsList.propTypes = {
  editSections: PropTypes.arrayOf(PropTypes.shape(editSectionShape)).isRequired,
  editItemData: PropTypes.object,
  sectionsInitialOpenStates: PropTypes.object,
  isEditDataLoading: PropTypes.bool
}

export default EditSectionsList
